import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import Header from "./components/header/";
import Sections from "./components/sections/Sections";
import NamiZen from "./components/namizen/NamiZen";
import NamiZenPrivacy from "./components/namizen/NamiZenPrivacy";

class App extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/">
            <div className="app">
              <Header />
              <Sections />
            </div>
          </Route>
          <Route exact path="/namizen">
            <NamiZen />
          </Route>
          <Route path="/namizen/privacy">
            <NamiZenPrivacy />
          </Route>
        </Switch>
      </Router>
    );
  }
}

export default App;
